import React from 'react';

type Pagination = {
  gotoPage: (updater: number | ((pageIndex: number) => number)) => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageIndex: number;
  pageOptions: number[];
  previousPage: () => void;
  nextPage: () => void;
  pageCount: number;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
};

const Pagination = ({
  gotoPage,
  canPreviousPage,
  pageIndex,
  pageOptions,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageSize,
  setPageSize
}: Pagination) => (
  <div
    style={{
      display: 'flex',
      borderRadius: '0 0 8px 8px',
      backgroundColor: '#fff',
      width: '100%',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '10px',
      flexWrap: 'wrap'
    }}
  >
    <div>
      <button
        className="mr-3 p-3"
        onClick={() => gotoPage(0)}
        disabled={!canPreviousPage}
      >
        {'<<'}
      </button>
      <button
        className="mr-3 p-3"
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
      >
        {'<'}
      </button>
      <button
        className="mr-3 p-3"
        onClick={() => nextPage()}
        disabled={!canNextPage}
      >
        {'>'}
      </button>
      <button
        className="mr-3 p-3"
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
      >
        {'>>'}
      </button>
    </div>

    <div className="flex">
      Page <p style={{ margin: '0 5px', fontWeight: 700 }}>{pageIndex + 1}</p>{' '}
      of{' '}
      <p style={{ margin: '0 5px', fontWeight: 700 }}>{pageOptions.length}</p>
    </div>
    <select
      style={{ cursor: 'pointer', marginLeft: '10px', width: '200px' }}
      value={pageSize}
      onChange={(e) => {
        setPageSize(Number(e.target.value));
      }}
    >
      {[10, 25, 50, 100].map((pageSize) => (
        <option key={pageSize} value={pageSize}>
          Show {pageSize}
        </option>
      ))}
    </select>
  </div>
);

export default Pagination;
